
import React from 'react';
import Layout from '../../components/Layout';
import SubNavBar from "../../components/SubNavBar/SubNavBar"
import DeleteAccount from './DeleteAccount';
import DeleteAccountPublic from './DeleteAccountPublic';


function action({ store, params, query }) {
  const title = store.getState().siteSettings?.data?.siteTitle
  const description = store.getState().siteSettings?.data?.metaDescription;
  let isAuthenticated = store.getState().runtime.isAuthenticated;

  if (!isAuthenticated) {
    // COMPLIANCE: Play's Data-safety "account deletion" URL must render a real logged-out page
    // (a redirect to home reads as an invalid resource to Google's checker).
    return {
      title: `Delete your account — ${title || 'BestHand'}`,
      description,
      component: (
        <Layout>
          <DeleteAccountPublic />
        </Layout>
      ),
    };
  }
  return {
    title,
    description,
    component: (
      <Layout>
        <div className={isAuthenticated ? "subPageMainContainer" : "withoutPageMainContainer"}>
          {isAuthenticated && <SubNavBar />}
          <DeleteAccount />
        </div>
      </Layout>
    ),
  };
}

export default action;
